export default "__VITE_ASSET__DEIX60lN__"